import {Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {HttpClient} from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Address } from '../../model/authentication/account.model';

@Injectable({
  providedIn: 'root'
})
export class AccountService extends BaseService {

  constructor(protected httpClient: HttpClient) {
    super();
  }

  addUserAddress(address: Address): Observable<any> {
    return this.httpClient.post(this.apiUrl + `address/`, address, this.httpOptionsFormData);
  }

  getUserAddresses(user_id: number): Observable<any> {
    return this.httpClient.get(this.apiUrl + `user/addresses/${user_id}/`, this.httpOptions);
  }

  setAddressAsDefault(address_id: number){
    return this.httpClient.post(this.apiUrl + `address/setDefault`, {'address_id': address_id}, this.httpOptionsFormData);
  }

  deleteAddress(addressId: number): Observable<any> {
    return this.httpClient.delete(this.apiUrl + `address/${addressId}/`, this.httpOptions);
  }

  getUserProfile(user_id): Observable<any> {
    return this.httpClient.get(this.apiUrl + `user/profile/${user_id}/`, this.httpOptions);
  }

  editUserProfile(profile) {
    return this.httpClient.post(this.apiUrl + `user/editProfile`, profile, this.httpOptionsFormData);
  }

  changePassword(data) {
    if (!data) { return; }
    return this.httpClient.post(this.apiUrl + `user/changePassword`,
      {password: data.password, new_password: data.new_password}, this.httpOptions);
  }

  getAccountInfo(disp_id) {
    return this.httpClient.get(this.apiUrl + `dispensary/${disp_id}/customerAccount/`, this.httpOptions);
  }
}
